import React, { Component, useState, useEffect } from 'react';
import './Form.css';
import { useTranslation } from 'react-i18next';
import './League.css';
import '@fortawesome/fontawesome-free/css/all.min.css';


const League = () => {

    useEffect(() => {
        document.title = "Liga Juara Rakan Grab";
        populateLeagueData();
    },[]);

    const [phoneNo, setPhoneNo] = useState('');
    const [icNo, setIcNo] = useState('');
    const { t } = useTranslation();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [vehicle, setVehicle] = useState('');
    const [league, setLeague] = useState('');
    const [name, setName] = useState('');
    const [rank, setRank] = useState('');
    const [points, setPoints] = useState('');
    const [prize, setPrize] = useState('');
    const [pointnext, setNextpoint] = useState('');
    const [pointnextbm, setNextpointbm] = useState('');
    const [crHealth, setCrHealth] = useState('');
    const [drHealth, setDrHealth] = useState('');
    const [updateDate, setUpdateDate] = useState('');
    const [page, setPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const { i18n } = useTranslation();

    const renderMessage = () => {
        let message = i18n.language === 'en' ? pointnext : pointnextbm;
        let lines = message.split('\\n');

        return (
            <div>
                {lines.map((line, index) => (
                    <div key={index}>{line}</div>
                ))}
            </div>
        );
    };
    const handleDatePage = () => {
        const date = new Date(updateDate);
        const result = date.toLocaleString('default', { month: 'short' }) + ' ' + date.getFullYear();
        return result;
    }
    //const handleSearch = (event) => {
    //    event.preventDefault();
    //    populateLeagueData(phoneNo, icNo);

    //}
    const handleNextPage = (event) => {
        event.preventDefault();
        if (currentPage != page) {
            const futurePage = currentPage + 1;
            setCurrentPage(futurePage)
            setVehicle(data[futurePage -1].vehicle_Cat)
            setLeague(data[futurePage - 1].league);
            setName(data[futurePage - 1].name);
            setRank(data[futurePage - 1].rank);
            setPoints(data[futurePage - 1].points);
            setPrize(data[futurePage - 1].entries);
            setNextpoint(data[futurePage - 1].message);
            setNextpointbm(data[futurePage - 1].messagebm);
            setUpdateDate(data[futurePage - 1].updateDate);
            setCrHealth(data[futurePage - 1].crHealth);
            setDrHealth(data[futurePage - 1].drHealth);
        }
    }
    const handlePreviousPage = (event) => {
        event.preventDefault();
        if (currentPage != 1) {
            const futurePage = currentPage -1;
            setCurrentPage(futurePage)
            setVehicle(data[futurePage - 1].vehicle_Cat)
            setLeague(data[futurePage - 1].league);
            setName(data[futurePage - 1].name);
            setRank(data[futurePage - 1].rank);
            setPoints(data[futurePage - 1].points);
            setPrize(data[futurePage - 1].entries);
            setNextpoint(data[futurePage - 1].message);
            setNextpointbm(data[futurePage - 1].messagebm);
            setUpdateDate(data[futurePage - 1].updateDate);
            setCrHealth(data[futurePage - 1].crHealth);
            setDrHealth(data[futurePage - 1].drHealth);
        }
    }
    const renderHealth = (health) => {
        if (health === 'True') {
            return <i className="far fa-check-circle" style={{ fontSize: '24px', color: '#00b14f' }}></i>;
        } else if(health == 'False') {
            return <i className="far fa-times-circle" style={{ fontSize: '24px', color: '#cc6633' }}></i>;
        }
        return <i className="far fa-question-circle" style={{ fontSize: '24px', color: '#959a9d' }}></i>;
    }

    async function populateLeagueData() {
        setDataLoaded(false);
        const encodedPhoneNo = encodeURIComponent(phoneNo ? phoneNo : 0);
        const encodedIcNo = encodeURIComponent(icNo ? icNo : 0);
        const response = await fetch(`leaguedetail/details`);
        const result = await response.json();
        setData(result);
        if (Array.isArray(result) && result.length) {
            setVehicle(result[0].vehicle_Cat)
            setLeague(result[0].league);
            setName(result[0].name);
            setRank(result[0].rank);
            setPoints(result[0].points);
            setPrize(result[0].entries);
            setNextpoint(result[0].message);
            setNextpointbm(result[0].messageBM);
            setUpdateDate(result[0].updateDate);
            setDrHealth(result[0].drHealth);
            setCrHealth(result[0].crHealth);
            setPage(result.length);
            setCurrentPage(1);
        } else {
            // Set default value "No data" if there is no response
            setVehicle('No data')
            setLeague('No data');
            setName('No data');
            setRank('No data');
            setPoints('No data');
            setPrize('No data');
            setNextpoint('No data');
            setNextpointbm('No data');
            setUpdateDate('No data');
            setDrHealth('No data');
            setCrHealth('No data');
           
            setPage(0);
            setCurrentPage(0);
        }
        setDataLoaded(true);

    }

    return (
        <div>                 
            {/*<form onSubmit={handleSearch} >*/}
            {/*    <div>*/}
            {/*        <table className="tb-form txt-font" style={{ width: '100%' }}>*/}
            {/*            <tr>*/}
            {/*                <td>{t('League.PhoneNo')}</td>*/}
            {/*                <td><input type="text" className="margB5px" required value={phoneNo} onChange={(e) => { const regex = new RegExp("^[0-9]{1,4}$"); if (!e.target.value || regex.test(e.target.value)) { setPhoneNo(e.target.value); } }} minLength="4" maxLength="4" placeholder="0000" /></td>*/}
            {/*            </tr>*/}
            {/*            <tr>*/}
            {/*                <td>{t('League.IcNo')}</td>*/}
            {/*                <td><input type="text" className="margB5px" required value={icNo} onChange={(e) => { const regex = new RegExp("^[0-9]{1,12}$"); if (!e.target.value || regex.test(e.target.value)) { setIcNo(e.target.value); } }} minLength= "12" maxLength="12" placeholder="901206105442" /></td>*/}
            {/*            </tr>*/}

            {/*        </table>*/}
            {/*        <div className="text-align-right txt-font text-padding-right-10px">*/}
            {/*                <button type="submit" className="btn-search" > <i className="fa fa-search"></i></button>*/}
            {/*        </div>*/}
            {/*        <span className='txt-font txt-typewriter' style={{ color: '#b46438' }} >{t('League.Explains')} </span>*/}
            {/*    </div>*/}
            {/*    <br />*/}
                {dataLoaded ?
                    <div>
                        <div className='div-leaderboard'>
                            <div className='div-leaderboard-header'>
                                <img src="https://spagblob.blob.core.windows.net/odin-image/reward.gif" alt="Animated GIF" width="42" height="60" />
                                <label className='lb-leaderboard'>Leaderboard</label>
                                <img src="https://spagblob.blob.core.windows.net/odin-image/reward.gif" alt="Animated GIF" width="42" height="60" />
                            </div>
                        </div>

                        <img src="https://spagblob.blob.core.windows.net/odin-image/sender.gif" alt="Animated GIF" width="100%" />
                        <table className='tb-league' style={{ width: '100%' }}>
                            {/*<tr>*/}
                            {/*    <td>{t('League.Vehicle')}</td>*/}
                            {/*    <td>{vehicle}</td>*/}
                            {/*</tr>*/}
                            <tr>
                                <td>{t('League.League')}</td>
                                <td>{league}</td>
                            </tr>
                            <tr>
                                <td>{t('League.Name')} </td>
                                <td>{name}</td>
                            </tr>
                            <tr>
                                <td>{t('League.Rank')} </td>
                                <td>{rank} </td>
                            </tr>
                            <tr>
                                <td>{t('League.Points')} </td>
                                <td>{points}</td>
                            </tr>
                            <tr>
                                <td>{t('League.PointNext')} </td>
                                <td>{renderMessage()}</td>
                            </tr>
                            <tr>
                                <td>{t('League.BonusPoint')} </td>
                                <td>{'Cancellation rate '} {renderHealth(crHealth)}<br></br> {'(+300 points)'} <br></br>{'Driver rating'}  {renderHealth(drHealth)}<br></br> {'(+300 points)'} </td>
                            </tr>
                            <tr>
                                <td>{t('League.Entries')} </td>
                                <td>{prize}</td>
                            </tr>
                            <tr>
                                <td>{t('League.Update')} </td>
                                <td>{updateDate}</td>
                            </tr>
                        </table>
                        <div className="div-page">
                            <button className="btn-page txt-font" disabled={currentPage === 1 || currentPage === 0} onClick={handlePreviousPage}>&lt;</button>
                            <label className="txt-font">{handleDatePage()}</label>
                            <button className="btn-page txt-font" disabled={currentPage === page} onClick={handleNextPage}>&gt;</button>
                        </div>
                    </div>
                    : null}
                {/*<br />*/}

        {/*    </form>*/}

        </div>
    );
}



export default League;
